/**
 * 시작 화면 UI. 제목 + 안내 문구 + "뿌셔!" 시작 버튼(재방문 시 최고 기록 표시).
 * 문구는 접속자 언어(i18n)로 표시. 사유 입력 없이 바로 시작한다.
 */
import type { Session } from '../gameplay/Session';
import { loadRecords } from '../storage/records';
import { t } from '../i18n/i18n';

export class StartQuestion {
  private root: HTMLElement;

  constructor(
    parent: HTMLElement,
    private session: Session,
  ) {
    this.root = document.createElement('div');
    this.root.className = 'overlay';
    this.root.innerHTML = `
      <div class="card">
        <h1>${t('title')}</h1>
        <div class="sub" style="margin-top:16px;font-size:15px;color:var(--fg);">${t('howto')}</div>
        <div class="best" id="dr-best"></div>
        <div class="row">
          <button class="btn" id="dr-start">${t('startBtn')}</button>
        </div>
        <div class="credit">${t('sfxCredit')}: <a href="https://freesound.org" target="_blank" rel="noopener noreferrer">freesound.org</a> — cmusounddesign (CC&nbsp;BY&nbsp;4.0) · qubodup · Supercow8399 (CC0)</div>
      </div>`;
    parent.appendChild(this.root);
    this.root.querySelector<HTMLButtonElement>('#dr-start')!.addEventListener('click', () => this.begin());
  }

  private begin(): void {
    this.hide();
    this.session.start();
  }

  show(): void {
    const best = loadRecords();
    const bestEl = this.root.querySelector<HTMLElement>('#dr-best')!;
    bestEl.textContent =
      best.bestScore > 0
        ? t('best', { score: best.bestScore.toLocaleString(), combo: best.bestCombo })
        : '';
    this.root.classList.remove('hidden');
    this.session.openQuestion();
  }

  hide(): void {
    this.root.classList.add('hidden');
  }
}
